import Controller from '@ember/controller';
import EmberObject from '@ember/object';
import { getOwner, setOwner } from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { task } from 'ember-concurrency';

import { getBem } from 'umg-ember-backend/utils/get-bem';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

import styles from './styles.module.css';

const Validations = buildValidations({
  url: validator('format', {
    type: 'url',
  }),
});

class QuickscanOptions extends EmberObject.extend(Validations) {
  id = 0;
  recordType = 'a11y-quickscan';
  @tracked url = '';
  isNew = true;

  constructor(owner, args) {
    super(owner, args);
    setOwner(this, owner);
  }

  toJSON() {
    let { url } = this;
    return { url };
  }

  reset() {
    this.url = '';
  }
}

export default class AdminA11yQuicksan extends Controller {
  // Service
  @service fetch;
  @service flashMessages;
  @service headData;
  @service intl;

  // Deafaults
  bem = getBem(styles);
  @tracked report;
  @tracked showErrors = false;
  quickscanOptions = new QuickscanOptions(getOwner(this));

  // Functions
  setHeadData = () => {
    this.headData.title = this.intl.t('a11y_quickscan.headline');
    this.headData.favicon = 'a11y-quickscan';
  };

  startScan = task(async () => {
    try {
      if (this.quickscanOptions.validations.isTruelyInvalid) {
        this.showErrors = true;
        return;
      }

      this.report = await this.fetch.post('/a11y/quickscan', {
        data: this.quickscanOptions.toJSON(),
      });
    } catch (error) {
      const message = error.payload?.errors?.message ?? error;
      this.flashMessages.error(message, {
        rawString: true,
      });
    }
  });
}
